export default __webpack_public_path__ + "static/media/marketing.ea1e3c4f.svg";